<template>
    <div class="row layout-spacing" v-if="shouldShowCards">
        <!-- Deposit Card -->
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
            <div class="widget widget-card-three kyc-success-card" @click="navigateToDeposit">
                <div class="widget-heading">
                    <div class="task-info">
                        <svg style="margin-right: 15px" width="48px" height="48px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#28a745" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M2 17L12 22L22 17" stroke="#28a745" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M2 12L12 17L22 12" stroke="#28a745" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <div>
                            <h5 class="kyc-card-title text-success">Go to Deposit</h5>
                            <p class="kyc-card-subtitle">Fund your account</p>
                        </div>
                    </div>
                </div>
                <div class="widget-content">
                    <p>Start funding your trading account with various payment methods.</p>
                </div>
            </div>
        </div>

        <!-- Crypto Card -->
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
            <div class="widget widget-card-three kyc-success-card" @click="navigateToCrypto">
                <div class="widget-heading">
                    <div class="task-info">
                        <svg style="margin-right: 15px" width="48px" height="48px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="10" stroke="#28a745" stroke-width="2"/>
                            <path d="M8 12L10.5 14.5L16 9" stroke="#28a745" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <div>
                            <h5 class="kyc-card-title text-success">Go to Crypto</h5>
                            <p class="kyc-card-subtitle">Crypto deposits</p>
                        </div>
                    </div>
                </div>
                <div class="widget-content">
                    <p>Deposit using cryptocurrency with secure blockchain technology.</p>
                </div>
            </div>
        </div>

        <!-- Trading Account Card -->
        <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12">
            <div class="widget widget-card-three kyc-success-card" @click="navigateToTrading">
                <div class="widget-heading">
                    <div class="task-info">
                        <svg style="margin-right: 15px" width="48px" height="48px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="10" fill="#28a745"/>
                            <path d="M7 13l3 3 7-7" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        <div>
                            <h5 class="kyc-card-title text-success">Trading Account</h5>
                            <p class="kyc-card-subtitle">Access MT5 platform</p>
                        </div>
                    </div>
                </div>
                <div class="widget-content">
                    <p>Login credentials sent to your email. Download MT5 to start trading.</p>
                    <a :href="mt5Link" target="_blank" style="color: #28a745; text-decoration: underline;">Download MT5</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import '@/assets/sass/widgets/widgets.scss';
import { useRouter, useRoute } from 'vue-router';
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const router = useRouter();
const route = useRoute();

const isKYCApproved = computed(() => {
    return store.state.user?.user_sumsub?.review_status === "completed" && store.state.user?.user_sumsub?.review_result === 1;
});

const shouldShowCards = computed(() => {
    return isKYCApproved.value;
});

const mt5Link = 'https://dynamicmarkets.com/platform';

const navigateToDeposit = () => {
    router.push('/account/deposit');
};

const navigateToCrypto = () => {
    router.push('/account/crypto');
};

const navigateToTrading = () => {
    window.open(mt5Link, '_blank');
};
</script>

<style scoped>
.kyc-success-card {
    cursor: pointer;
    transition: all 0.3s ease;
    border: 2px solid #e0e6ed;
    height: 100%;
}

.kyc-success-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 20px rgba(0,0,0,0.1);
    border-color: #28a745;
}

.kyc-card-title {
    font-weight: 700;
    color: #28a745;
    font-size: 1.1rem;
    margin-bottom: 0.25rem;
}

.kyc-card-subtitle {
    font-size: 0.9rem;
    color: #6c757d;
    margin-bottom: 0;
}

.widget-content p {
    font-size: 0.95rem;
    font-weight: 500;
    margin-bottom: 0.5rem;
}

.task-info {
    display: flex;
    align-items: center;
    width: 100%;
}

.widget-heading {
    margin-bottom: 1rem;
}
</style>
